import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { toast } from "react-toastify";
import { getAbout, addAbout } from "../../../../../libs/api/aboutApi";
import LoadingSpinner from "../../../../../libs/LoadingSpinner";
import useLanguage from "../../../../../hooks/useLanguage";

export default function AboutUs() {
  const { t } = useLanguage();
  const [editorState1, setEditorState1] = useState(EditorState.createEmpty());
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [about, setAbout] = useState(null);

  useEffect(() => {
    fetchAbout();
  }, []);

  useEffect(() => {
    const rawContent = convertToRaw(editorState1.getCurrentContent());
    setAbout(JSON.stringify(rawContent));
  }, [editorState1]);

  const fetchAbout = async () => {
    setLoading(true);
    try {
      const response = await getAbout();
      if (response.status === 200 || response.status === 201) {
        const data = response.data.data[0].description;
        let contentState;
        try {
          const rawContent = JSON.parse(data);
          contentState = convertFromRaw(rawContent);
        } catch (e) {
          contentState = ContentState.createFromText(data);
        }
        setEditorState1(EditorState.createWithContent(contentState));
      } else {
        toast.error(response?.response?.data?.message || response?.message || t('messages.somethingWentWrong'));
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || t('messages.somethingWentWrong'));
    } finally {
      setLoading(false);
    }
  }

  const handleSave = async () => {
    setAddLoading(true);
    try {
      const payload = {
        description: about
      }
      const response = await addAbout(payload);
      if (response.status === 200 || response.status === 201) {
        toast.success(response?.data?.message || t('messages.updatedSuccess'));
      } else {
        toast.error(response?.response?.data?.message || response?.message || t('messages.somethingWentWrong'));
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || t('messages.somethingWentWrong'));
    } finally {
      setAddLoading(false);
    }
  }

  return (
    <div className="p-6 h-full flex flex-col">
      <h2 className="text-2xl font-semibold mb-4">{t('aboutUs.title')}</h2>
      {loading ? (
        <div className="flex justify-center items-center h-full pb-10">
          <LoadingSpinner />
        </div>
      ) : (
        <>

          <div className="border border-gray-300 rounded-lg p-2 flex-1 relative bg-white">
            <Editor
              editorState={editorState1}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor max-h-[300px]"
              onEditorStateChange={setEditorState1}
            />
          </div>
          <div className="w-full bg-[#FAFAFA] py-3 flex justify-end px-6 rounded-b-md">
            <button
              type="button"
              className="btn bg-[#0D6EFD] rounded-xl p-2 px-5 text-white hover:bg-blue-700"
              onClick={handleSave}
              disabled={addLoading}
            >
              {addLoading ? <LoadingSpinner /> : t('common.save')}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
